import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import { signLogin } from '../api/user'

Vue.use(VueRouter)

const routes = [

  // {
  //   path: '/',
  //   redirect: { name: 'home' }
  // },
  {
    path: '/',
    name: 'home',
    component: Home,
  },
]

const router = new VueRouter({
  mode: 'hash',
  // base: '/cource',
  base: '/source',

  routes
})
router.beforeEach((to, from, next) => {
  // console.log(456);

  if (localStorage.getItem("token") && localStorage.getItem("token") != "undefined") {
    // console.log(4578, localStorage.getItem("token"));
    next();
  } else {
    console.log(456123, process.env.VUE_APP_LOGIN_URL);

    let url = window.location.search;
    // console.log('urlurl', url);

    if (url) {
      const urlObj = new URLSearchParams(url);
      const code = urlObj.get("code");
      const appid = urlObj.get('appid');
      // console.log('urlObj', urlObj);

      if (code && !appid) {
        console.log(appid, "codeppp", code);
        signLogin({ code: code }).then(
          (res) => {
            if (res.token == "") {
              localStorage.clear();
              window.location.href = process.env.VUE_APP_LOGIN_URL;
              localStorage.removeItem("token");
            } else {
              localStorage.setItem("token", res.token);
              next();
            }
          },
          (req) => {
            console.log("ressssatoken", res);
            localStorage.clear();
            window.location.href = process.env.VUE_APP_LOGOUT_URL;
          }
        );
      }
      // else if (!code && !appid) {
      //   console.log('!code && !appid');

      //   localStorage.clear();
      //   window.location.href = process.env.VUE_APP_LOGOUT_URL;
      // } else if (!code && appid) {
      //   console.log('!code && appid');
      //   localStorage.clear();
      //   window.location.href = process.env.VUE_APP_LOGOUT_URL;
      // }
      // else {
      //   console.log("elseclear");
      //   localStorage.clear();
      //   window.location.href = process.env.VUE_APP_LOGOUT_URL;
      // }
    } else {
      localStorage.clear();
      window.location.href = process.env.VUE_APP_LOGIN_URL;
    }
  }
});

export default router
